import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient.ts';

function ContactsList() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContacts = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('contacts')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) {
        setError(error.message);
        setContacts([]);
      } else {
        setContacts(data);
        setError(null);
      }
      setLoading(false);
    };

    fetchContacts();
  }, []);

  if (loading) return <p style={{ textAlign: 'center', marginTop: 40 }}>Chargement des contacts...</p>;
  if (error) return <p style={{ color: 'red', textAlign: 'center', marginTop: 40 }}>Erreur: {error}</p>;

  return (
    <div
      style={{
        padding: '50px',
        maxWidth: '1200px', // wider container
        margin: '0 auto',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
      }}
    >
      <h2 style={{ textAlign: 'center', marginBottom: 30, color: '#333', fontWeight: '700' }}>Liste des contacts</h2>
      {contacts.length === 0 && <p style={{ textAlign: 'center', fontStyle: 'italic' }}>Aucun contact trouvé.</p>}
      <table
        style={{
          width: '100%',
          borderCollapse: 'separate',
          borderSpacing: '0 12px',
        }}
      >
        <thead>
          <tr>
            {['Nom', 'Email', 'Message', 'Date', 'Actions'].map((header) => (
              <th
                key={header}
                style={{
                  textAlign: 'left',
                  padding: '14px 18px',
                  backgroundColor: '#ffe6f0', // light pink header
                  color: '#b30059', // deep pink text
                  fontWeight: '600',
                  fontSize: '14px',
                  borderRadius:
                    header === 'Nom'
                      ? '8px 0 0 8px'
                      : header === 'Actions'
                        ? '0 8px 8px 0'
                        : '0',
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {contacts.map((contact) => (
            <tr
              key={contact.id}
              style={{
                backgroundColor: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                transition: 'background-color 0.3s ease',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#fff0f6')} // very light pink hover
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fff')}
            >
              <td style={{ padding: '14px 18px', fontWeight: '600', color: '#222' }}>{contact.name}</td>
              <td
                style={{
                  padding: '14px 18px',
                  color: contact.hide_email ? '#999' : '#ff4d94',
                  fontStyle: contact.hide_email ? 'italic' : 'normal',
                }}
              >
                {contact.hide_email ? 'Adresse cachée' : contact.email}
              </td>
              <td
                style={{
                  padding: '14px 18px',
                  maxWidth: 400, // more space for messages
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  color: '#444',
                }}
              >
                {contact.message}
              </td>
              <td style={{ padding: '14px 18px', color: '#666', fontSize: '13px' }}>
                {new Date(contact.created_at).toLocaleString()}
              </td>
              <td style={{ padding: '14px 18px' }}>
                {!contact.hide_email && (
                  <a
                    href={`mailto:${contact.email}?subject=Réponse à votre message`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}
                  >
                    <button
                      style={{
                        backgroundColor: '#ff4d94', // pink button
                        color: '#fff',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: 6,
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '14px',
                        boxShadow: '0 2px 5px rgba(255,77,148,0.4)',
                        transition: 'background-color 0.3s ease',
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#cc0066')}
                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#ff4d94')}
                    >
                      Répondre
                    </button>
                  </a>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ContactsList;
